import { StyleSheet } from 'aphrodite';
import { brandPrimary, charmGray, white } from '../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		padding: '16px',
		backgroundColor: white,
		overflow: 'hidden',
	},
	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		borderBottom: `1px solid ${charmGray}`,
		paddingBottom: '12px',
		marginBottom: '16px',
	},
	headerContent: {
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
	},
	headerIcon: {
		width: '20px',
		height: '20px',
		color: brandPrimary,
	},
	title: {
		fontSize: '18px',
		fontWeight: 600,
		color: brandPrimary,
		margin: 0,
	},
	closeButton: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '28px',
		height: '28px',
		padding: 0,
		border: 'none',
		borderRadius: '4px',
		backgroundColor: 'transparent',
		cursor: 'pointer',
		':hover': {
			backgroundColor: 'rgba(0, 0, 0, 0.05)',
		},
	},
	content: {
		flex: 1,
		minHeight: 0,
		overflowY: 'auto',
		display: 'flex',
		flexDirection: 'column',
	},
	messagesContainer: {
		flex: 1,
		minHeight: 0,
		overflowY: 'auto',
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
	},
	messageCard: {
		padding: '12px',
		borderRadius: '8px',
		backgroundColor: '#f5f5f5',
		border: '1px solid #e0e0e0',
	},
	userMessage: {
		backgroundColor: '#e3f2fd',
		borderColor: '#90caf9',
	},
	assistantMessage: {
		backgroundColor: '#f5f5f5',
		borderColor: '#e0e0e0',
	},
	messageRole: {
		fontSize: '12px',
		fontWeight: 600,
		color: brandPrimary,
		textTransform: 'uppercase',
		marginBottom: '8px',
		display: 'flex',
		alignItems: 'center',
		gap: '8px',
	},
	messageContent: {
		fontSize: '14px',
		lineHeight: '1.5',
		color: '#333',
	},
	streamingIndicator: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: '4px',
		fontSize: '11px',
		color: brandPrimary,
		fontWeight: 400,
		textTransform: 'none',
	},
	loadingContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '8px',
		padding: '24px',
		color: charmGray,
	},
	emptyState: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '24px',
		color: charmGray,
		textAlign: 'center',
	},
	inputContainer: {
		marginTop: '16px',
		paddingTop: '16px',
		borderTop: `1px solid ${charmGray}`,
	},
	textarea: {
		width: '100%',
		padding: '10px',
		borderRadius: '8px',
		border: `1px solid ${charmGray}`,
		fontSize: '14px',
		fontFamily: 'inherit',
		resize: 'none',
		boxSizing: 'border-box',
		':focus': {
			outline: 'none',
			borderColor: brandPrimary,
		},
	},
	buttonContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
		marginTop: '8px',
	},
});
